module.exports = __webpack_public_path__ + "img/bos26.0789d220.webp";